import { createFeatureSelector, createSelector } from "@ngrx/store";
import { flowRateCalculateFeatureKey } from "./flow-rate-calculate.reducer";

export const selectFlowRateCalculateState = createFeatureSelector(flowRateCalculateFeatureKey);

export const selectFlowRateCalculate = createSelector(
  selectFlowRateCalculateState,
  (state: any) => state
);
